export enum AuthErrorCode {
	ACCOUNT_INACTIVE = 'ACCOUNT_INACTIVE',
}

export const ACCOUNT_INACTIVE_MESSAGE = 'Your account is pending activation. Contact an administrator.'
